import { MutableRefObject } from 'react';
import type ReactECharts from 'echarts-for-react';
import { Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { saveChartAsPdf } from './helpers';
import classes from './DownloadChartBtn.module.scss';

type DownloadChartBtnPropsType = {
  chartRef: MutableRefObject<ReactECharts | null>;
  fileName: string;
};

export const DownloadChartBtn = ({ chartRef, fileName }: DownloadChartBtnPropsType) => {
  const saveChart = async () => {
    const chartInstance = chartRef?.current?.getEchartsInstance();
    await saveChartAsPdf(chartInstance, fileName);
  };

  return (
    <Tooltip placement="left" title="Save chart as PDF">
      <Button
        className={classes.downloadPdfBtn}
        icon={<DownloadOutlined className={classes.downloadPdfBtnIcon} />}
        type="default"
        onClick={saveChart}
      />
    </Tooltip>
  );
};
